import React from 'react';
import { Breadcrumb as AntBreadcrumb } from 'antd';

interface LMSBreadcrumbProps {
  courseName: string | undefined;
}

export default function LMSBreadcrumb({ courseName }: LMSBreadcrumbProps) {
  return (
    <AntBreadcrumb style={{ margin: '0 0 16px' }}>
      <AntBreadcrumb.Item>
        <a href="/lms">LMS</a>
      </AntBreadcrumb.Item>
      <AntBreadcrumb.Item>{courseName}</AntBreadcrumb.Item>
    </AntBreadcrumb>
  );
}
